import React from 'react'
import PropTypes from 'prop-types'
import { on } from 'events';

const FieldWrapper = (props) => {
  const { children, name, title, x2, className, onClick } = props;

  return (
    <div className={`${name} ${x2 ? 'x2' : ''} ${className || ''}`} onClick={onClick}>
      {children}
      <label htmlFor={name}>{title}</label>
    </div>
  );
}

FieldWrapper.propTypes = {
  children: PropTypes.any.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  x2: PropTypes.bool,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

FieldWrapper.defaultProps = {
  x2: false,
};

export default FieldWrapper


